// Pantalla del portal al que el usuario no tiene entrada: dice por qué y ofrece a dónde ir.
import { Link } from '@tanstack/react-router';
import { ShieldOff } from 'lucide-react';
import { useAuth } from '@/hooks/useAuth';
import { hasMultiplePortals } from '@/app/entry/portalAccess';

/** Portal sin ninguna pantalla para este usuario. `portalTitle` nombra el portal bloqueado. */
export function PortalAccessDenied({ portalTitle }: { portalTitle: string }) {
    const { permissions } = useAuth();
    return (
        <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-background px-6 text-center">
            <span className="flex size-12 items-center justify-center rounded-2xl bg-muted text-muted-foreground">
                <ShieldOff className="size-6" aria-hidden />
            </span>
            <h1 className="text-lg font-semibold text-foreground">
                No tienes acceso a este portal
            </h1>
            <p className="max-w-md text-sm leading-relaxed text-muted-foreground">
                Tu cuenta no tiene permisos para ninguna pantalla del {portalTitle}. Si crees que es
                un error, contacta a tu administrador.
            </p>
            {hasMultiplePortals(permissions) && (
                <Link
                    to="/select-role"
                    className="rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground transition-colors hover:opacity-90"
                >
                    Elegir otro portal
                </Link>
            )}
        </div>
    );
}
